<template>
  <div>
    <v-btn small text @click="openHelp(name)">
      <v-icon right>mdi-help-circle-outline</v-icon>
    </v-btn>

    <v-dialog v-model="openHelpModal" width="640">
      <v-card>
        <!-- TEXT -->
        <v-card-text class="pa-4" v-html="helpText" />

        <!-- DIALOG ACTIONS -->
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn text @click="openHelpModal = false"
            ><lang t="GLOBAL-BTN-CLOSE"></lang
          ></v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
export default {
  name: "HelpTextBtn",
  props: {
    name: {
      type: String,
      required: true,
    },
    title: {
      type: String,
    },
  },
  computed: {
    dialogTitle() {
      if (!this.title) return this.$i18n.t(`HELP_${this.name}`);
      return this.title;
    },
  },
  data() {
    return {
      helpText: "",
      openHelpModal: false,
    };
  },
  methods: {
    openHelp(name) {
      this.axios.get(`helptexts/byName/${name}`).then((res) => {
        this.helpText = res.data.content;
        this.openHelpModal = true;
      });
    },
  },
};
</script>

<style lang="scss" scoped></style>
